// src/App.js
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import Contact from './pages/Contact';
import SoftwareParana from './pages/SoftwareParana'; // <-- NUEVO
import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// ...tus imports

function ScrollHandler() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Si hay hash -> intentamos hacer scroll al elemento
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        // pequeño delay para asegurar que el layout esté listo
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 0);
      }
    } else {
      // sin hash -> scrollear arriba en cada cambio de ruta
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname, hash]);

  return null;
}


function App() {
  return (
    <Router>
      <ScrollHandler /> {/* <-- agrega esto aquí */}
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          {/*<Route path="/products" element={<Products />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/software-parana" element={<SoftwareParana />} />*/}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;